import React, { useEffect, useImperativeHandle, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { store } from '@/configurations'

import '@/companys/ttl/assets/styles/components/detail-center/options_table_fun.scss';

import classnames from 'classnames';

import NoRow from '@/components/DataTable/CustomNoRow';

const cloumns = {
    left: {
        chilren: [
            { headerName: 'market_options_iv', colId: 'call_iv' },
            { headerName: 'market_options_vega', colId: 'call_vega' },
            { headerName: 'market_options_theta', colId: 'call_theta' },
            { headerName: 'market_options_gamma', colId: 'call_gamma' },
            { headerName: 'market_options_delta', colId: 'call_delta' },
            { headerName: 'market_options_turnover', colId: 'call_turnover' },
            { headerName: 'common_volume', colId: 'call_volume' },
            { headerName: 'market_options_ask_volume', colId: 'call_ask_volume' },
            { headerName: 'market_options_ask_price', colId: 'call_ask_price' },
            { headerName: 'market_options_bid_volume', colId: 'call_bid_volume' },
            { headerName: 'market_options_bid_price', colId: 'call_bid_price' },
            { headerName: 'common_open', colId: 'call_open' },
            { headerName: 'market_options_price', colId: 'call_price' }]
    },
    center: {
        chilren: [
            {
                headerName: 'market_options_strike'
            }
        ]
    },
    right: {
        chilren: [
            { headerName: 'market_options_price', colId: 'put_price' },
            { headerName: 'common_open', colId: 'put_open' },
            { headerName: 'market_options_bid_price', colId: 'put_bid_price' },
            { headerName: 'market_options_bid_volume', colId: 'put_bid_volume' },
            { headerName: 'market_options_ask_price', colId: 'put_ask_price' },
            { headerName: 'market_options_ask_volume', colId: 'put_ask_volume' },
            { headerName: 'common_volume', colId: 'put_volume' },
            { headerName: 'market_options_turnover', colId: 'put_turnover' },
            { headerName: 'market_options_delta', colId: 'put_delta' },
            { headerName: 'market_options_gamma', colId: 'put_gamma' },
            { headerName: 'market_options_theta', colId: 'put_theta' },
            { headerName: 'market_options_vega', colId: 'put_vega' },
            { headerName: 'market_options_iv', colId: 'put_iv' },
        ]
    },
};

function getBarScorllWidth() {
    const outer = document.createElement('div');
    outer.className = 'app-container';
    outer.style.visibility = 'hidden';
    outer.style.width = '100px';
    document.getElementsByClassName('app-container')[0].appendChild(outer);

    const widthNoScroll = outer.offsetWidth;
    outer.style.overflow = 'scroll';

    const inner = document.createElement('div');
    inner.style.width = '100%';
    outer.appendChild(inner);

    const widthWithScroll = inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    const scrollBarWidth = widthNoScroll - widthWithScroll;

    return scrollBarWidth;
}

const OptionsTable = React.forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({  
        handleRestScroll,
        getBarScorllWidth,
        tableHeaderLeftRef,
        tableBodyLeftRef,
        tableFooterLeftRef
    }))

    const dispatch = useDispatch()
    const language = store.getState().app.language

    const tableHeaderLeftRef = useRef();
    const tableHeaderRightRef = useRef();
    const tableBodyLeftRef = useRef();
    const tableBodyCenterRef = useRef();
    const tableBodyRightRef = useRef();
    const tableFooterLeftRef = useRef();
    const tableFooterRightRef = useRef();

    const leftList = cloumns.left.chilren;
    const centerList = cloumns.center.chilren;
    const rightList = cloumns.right.chilren;

    const handleRestScroll = () => {
        const tableFooterLeftScroll = tableFooterLeftRef.current.getElementsByClassName('table-footer-scroll')[0];
        const tableFooterRightScroll = tableFooterRightRef.current.getElementsByClassName('table-footer-scroll')[0];

        const scrollMaxWidth = tableHeaderLeftRef.current.scrollWidth;
        const scrollRemovableWidth = scrollMaxWidth - tableHeaderLeftRef.current.offsetWidth;
        tableHeaderLeftRef.current.scrollLeft = scrollRemovableWidth;
        tableBodyLeftRef.current.scrollLeft = scrollRemovableWidth;
        tableFooterLeftScroll.style.width = `${scrollMaxWidth}px`;
        tableFooterRightScroll.style.width = `${scrollMaxWidth}px`;

        tableFooterLeftRef.current.scrollLeft = scrollRemovableWidth;

        setTimeout(() => {
            tableFooterLeftRef.current.onscroll = function (event) {
                const scrollPosition = Math.abs(event.srcElement.scrollLeft - scrollRemovableWidth);
                if (tableFooterRightRef.current.scrollLeft !== scrollPosition) {
                    tableFooterRightRef.current.scrollLeft = scrollPosition;
                }
                tableHeaderLeftRef.current.scrollLeft = event.srcElement.scrollLeft;
                tableBodyLeftRef.current.scrollLeft = event.srcElement.scrollLeft;
            };

            tableFooterRightRef.current.onscroll = function (event) {
                const scrollPosition = scrollRemovableWidth - event.srcElement.scrollLeft;
                if (tableFooterLeftRef.current.scrollLeft !== scrollPosition) {
                    tableFooterLeftRef.current.scrollLeft = scrollPosition;
                }
                tableHeaderRightRef.current.scrollLeft = event.srcElement.scrollLeft;
                tableBodyRightRef.current.scrollLeft = event.srcElement.scrollLeft;
            };
        });
    }

    useEffect(() => {
        handleRestScroll()
        window.addEventListener('resize', handleRestScroll)
        return () => window.removeEventListener('resize', handleRestScroll)
    }, []);
    return (
        <div className='table-container'>
            <div className='table-header'>
                <div className='table-header-left' ref={tableHeaderLeftRef} style={{ display: props.currentRadio == 'call' ? 'none' : '' }} >
                    <div className='table-header-wrapper'>
                        {leftList.map(item => {
                            return (
                                <div className='table-header-item' key={item.headerName}>
                                    {language[item.headerName]}
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className='table-header-center'>
                    <div className='table-header-center-wrapper'>
                        {centerList.map(item => {
                            return (
                                <div className='table-header-center-item' key={item.headerName} style={{display:'flex'}} >
                                    <span style={{color:"#1996E3" }} > { '<' +  language.market_options_call + '> ' }</span>
                                    <div>{ language[item.headerName] }</div>
                                    <span  style={{color:"#1996E3"}}>{ ' <' + language.market_options_put + '>' }</span>
                                    {/* {language[item.headerName]} */}
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className='table-header-right' ref={tableHeaderRightRef} style={{ display: props.currentRadio == 'put' ? 'none' : '' }} >
                    <div className='table-header-wrapper'>
                        {rightList.map(item => {
                            return (
                                <div className='table-header-item' key={item.headerName}>
                                    {language[item.headerName]}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            <div className='table-body'>
                <div className='table-body-scroll-wrapper'>
                    <div className='table-body-left' ref={tableBodyLeftRef} style={{ display: props.currentRadio == 'call' ? 'none' : 'flex' }} >
                        { props.OptionsTableFunData.map((dataItem, index) => {
                            return (
                                <div className='table-body-wrapper' key={index}>
                                    {leftList.map(listItem => {
                                        return (
                                            <div className={classnames('table-body-item',listItem.colId == 'call_open' ? dataItem.call_open_classStyle : '' )} key={listItem.headerName}  >
                                                {dataItem[listItem.colId]}
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </div>
                    <div className='table-body-center' ref={tableBodyCenterRef} style={{ marginRight: props.currentRadio == 'put' ? `-${getBarScorllWidth()}px` : '', }} >
                        { props.OptionsTableFunData.map((dataItem, index) => {
                            return (
                                <div className='table-body-wrapper' key={index}>
                                    <div className='table-body-item'>
                                        <span  style={{color:"#1996E3" ,marginRight:'20px' }} >{'C'}</span>
                                       <div>{dataItem['center']}</div> 
                                       <span style={{color:"#1996E3",marginLeft:'20px'}}>{'P'}</span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className='table-body-right' ref={tableBodyRightRef} style={{ marginRight: `-${getBarScorllWidth()}px`, display: props.currentRadio == 'put' ? 'none' : '' }}>
                        {props.OptionsTableFunData.map((dataItem, index) => {
                            return (
                                <div className='table-body-wrapper' key={index}>
                                    {rightList.map(listItem => {
                                        return (
                                            <div className={classnames('table-body-item',listItem.colId == 'put_open' ? dataItem.put_open_classStyle : '')} key={listItem.headerName}>
                                                {dataItem[listItem.colId]}
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </div>
                </div>
                { !props.load && props.OptionsTableFunData.length == 0 && 
                <NoRow style={{ display:'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' ,minHeight:'200px', width :'100%'}} />
                }
            </div>
            <div className='table-footer'>
                <div className='table-footer-left' ref={tableFooterLeftRef} style={{ display: props.currentRadio == 'call' ? 'none' : '' }} >
                    <div className='table-footer-wrapper'>
                        <div className='table-footer-scroll'></div>
                    </div>
                </div>
                <div className='table-footer-center'></div>
                <div className='table-footer-right' ref={tableFooterRightRef} style={{ display: props.currentRadio == 'put' ? 'none' : '' }} >
                    <div className='table-footer-wrapper'>
                        <div className='table-footer-scroll'></div>
                    </div>
                </div>
            </div>
        </div>
    );
})


export default OptionsTable;
